/* Public links never expose review controls. */
if(!['localhost','127.0.0.1'].includes(location.hostname)||new URLSearchParams(location.search).get('layout-edit')!=='1'){const style=document.createElement('style');style.textContent='.moringa-edit-tools,.layout-resume,.layout-hover-lock,.section-history,.swipe-hint-control,.mobile-shape-control{display:none!important}';document.head.append(style);}
/* AMKA main menu behaviour. Desktop: hover AND click open the shelf, Escape closes and
   returns focus, focus leaving the panel closes it. Mobile: a row opens a SUBPANEL with a
   Back button and expandable groups, and the body scroll is locked while it is open.

   It drives the shelves this page already has rather than replacing them, so no page gets
   an old version rewritten underneath it. */
(function () {
  var shelves = [].slice.call(document.querySelectorAll('.mshelf'));
  // ONE breakpoint, the same number /cdn/shop/t/5/assets/menu--64e50f8d.css uses: the desktop panel needs 1200 to fit.
  var phone = function () { return matchMedia('(max-width:1199px)').matches; };
  var lastTrigger = null;

  function close(sh) {
    var top = sh.querySelector('.mtop'), panel = sh.querySelector('.mega');
    if (!panel) return;
    delete sh.dataset.pinned;
    panel.hidden = true;
    sh.removeAttribute('data-open');
    if (top) top.setAttribute('aria-expanded', 'false');
  }
  function closeAll() { shelves.forEach(close); }

  function open(sh) {
    closeAll();
    var top = sh.querySelector('.mtop'), panel = sh.querySelector('.mega');
    if (!panel) return;
    panel.hidden = false;
    sh.setAttribute('data-open', '');
    if (top) top.setAttribute('aria-expanded', 'true');
  }

  shelves.forEach(function (sh) {
    var top = sh.querySelector('.mtop');
    if (!top) return;
    /* HOVER OPENS, and a small delay on leaving means crossing the gap between the word
       and the panel does not shut it. Dion: "on scrolling, menu disappears or product
       links cannot be clicked". */
    var leaveT = null;
    sh.addEventListener('mouseenter', function () {
      clearTimeout(leaveT);
      if (!phone()) open(sh);
    });
    sh.addEventListener('mouseleave', function () {
      if (phone() || sh.dataset.pinned) return;      // pinned by a click: it stays
      clearTimeout(leaveT);
      leaveT = setTimeout(function () { close(sh); }, 220);
    });
    // Keyboard reaches the panel by focusing the link; the pointer reaches it by hovering.
    // The click stays a plain link to /shop/. It used to preventDefault and TOGGLE, which
    // meant a real click closed the panel hover had just opened one event earlier: the
    // pointer was already inside, so no mouseenter ever fired again to reopen it.
    top.addEventListener('focus', function () { if (!phone()) { lastTrigger = top; open(sh); } });
    /* CLICK PINS THE PANEL rather than navigating. Dion: "clicking Shop navigates straight
       to shop rather than allowing expected menu interaction". Shop all inside the panel
       still goes to /shop/, so the destination is not lost. A second click unpins and
       closes, and the earlier hover-then-click collision cannot come back because a click
       never toggles a hover-opened panel shut on its first press. */
    top.addEventListener('click', function (e) {
      if (phone()) return;
      e.preventDefault();
      lastTrigger = top;
      // PIN AFTER OPENING. open() calls closeAll(), and close() clears the pin, so
      // setting it first wiped it in the same tick and the panel shut on mouseleave.
      if (sh.dataset.pinned) { close(sh); }
      else { open(sh); sh.dataset.pinned = '1'; }
    });
    // focus leaving the whole shelf closes it, so a keyboard user is never trapped
    sh.addEventListener('focusout', function (e) {
      if (!phone() && !sh.contains(e.relatedTarget)) close(sh);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sub = document.querySelector('.msub[data-open]');
    if (sub) { closeSub(sub); return; }
    var drop = document.getElementById('menu');
    if (drop && drop.classList.contains('open')) { closeEverything(); return; }   /* scan 2026-09-24: Escape left the phone menu open */
    var open_ = document.querySelector('.mshelf[data-open]');
    if (open_) {
      close(open_);
      var t = lastTrigger || open_.querySelector('.mtop');
      if (t) t.focus();
    }
  });

  /* ---- the phone subpanel: Back, accordions, scroll lock ---- */
  function openSub(sub) {
    sub.setAttribute('data-open', '');
    document.body.setAttribute('data-menu-lock', '');
    var back = sub.querySelector('.mback');
    if (back) back.focus();
  }
  function closeSub(sub) {                      // BACK: one layer, return to the rows
    sub.removeAttribute('data-open');
    document.body.removeAttribute('data-menu-lock');
    if (lastTrigger) lastTrigger.focus();
  }
  /* CLOSE: every layer, and focus back on the hamburger that opened all this.
     Root's retest: Close was only dismissing the subpanel and leaving the legacy drawer
     open underneath with aria-expanded still true. */
  function closeEverything() {
    var sub = document.querySelector('.msub[data-open]');
    if (sub) sub.removeAttribute('data-open');
    var legacy = document.getElementById('menu');
    if (legacy) legacy.classList.remove('open');
    document.body.removeAttribute('data-menu-lock');
    var btn = document.getElementById('menubtn');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-subopen]');
    if (opener) {
      var sub = document.getElementById(opener.getAttribute('data-subopen'));
      if (sub) { lastTrigger = opener; openSub(sub); }
      return;
    }
    if (e.target.closest('.mclose')) { closeEverything(); return; }
    var back = e.target.closest('.mback');            // Back returns to the first level
    if (back) { closeSub(back.closest('.msub')); return; }
    var acc = e.target.closest('.macc > button');
    if (acc) {
      var box = acc.parentNode, was = box.hasAttribute('data-open');
      box.toggleAttribute('data-open', !was);
      acc.setAttribute('aria-expanded', String(!was));
    }
  });

  /* THE HAMBURGER ITSELF. This lived as an inline IIFE on every page, so the shared
     menu owned the subpanels while each page separately owned the drawer. Root found the
     old copy back on a rebuilt product page and was right that the behaviour has to have
     ONE owner; menu_apply strips the inline one now and this is it. The guard attribute
     means a page that somehow still carries its own copy cannot double-toggle. */
  (function () {
    var btn = document.getElementById('menubtn'), drawer = document.getElementById('menu');
    if (!btn || !drawer || btn.dataset.menuBound) return;
    btn.dataset.menuBound = '1';
    btn.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) {          // closest(), not target.tagName: a click lands
        drawer.classList.remove('open');    // on the <b> or the <img> inside the link
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  })();

  addEventListener('resize', function () {
    if (phone()) { closeAll(); return; }
    // crossing up to desktop: the legacy drawer and any subpanel must not survive
    var legacy = document.getElementById('menu');
    if (legacy) legacy.classList.remove('open');
    var btn = document.getElementById('menubtn');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    var sub = document.querySelector('.msub[data-open]');
    if (sub) sub.removeAttribute('data-open');
    document.body.removeAttribute('data-menu-lock');
  });
})();

// Keep ordinary web links inside the current review browser, not an external window.
(()=>{
  const keepInside=()=>document.querySelectorAll('a[target]').forEach(a=>{
    if(/^https?:$/.test(a.protocol))a.target='_self';
  });
  keepInside();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',keepInside,{once:true});
  document.addEventListener('click',e=>{
    const a=e.target.closest('a[href]');
    if(a&&/^https?:$/.test(a.protocol))a.target='_self';
  },true);
})();

// Shared storefront editor: page-local drafts and one persistent pill.
(()=>{
 const base=new URL('.',document.currentScript.src);
 async function load(){
  await new Promise(resolve=>{const css=document.createElement("link");css.rel="stylesheet";css.href=new URL("/cdn/shop/t/5/assets/shelf-layout--2a74233f.css",base);css.onload=resolve;css.onerror=resolve;document.head.append(css);});
  if((window.AMKA_ROUTE||location.pathname).startsWith('/pdp/')){await new Promise(resolve=>{const p=document.createElement('script');p.src=new URL('/cdn/shop/t/5/assets/product-polish--45b1c30d.js',base);p.onload=resolve;p.onerror=resolve;document.body.append(p);});if(window.amkaProductReady)await window.amkaProductReady;}
  if((window.AMKA_ROUTE||location.pathname).startsWith('/pdp/'))await new Promise(resolve=>{const p=document.createElement('script');p.src=new URL('/cdn/shop/t/5/assets/product-stories--648ee79a.js',base);p.onload=resolve;p.onerror=resolve;document.body.append(p);});
  await new Promise(resolve=>{const p=document.createElement('script');const cv=new URLSearchParams(location.search).get('coffee-version');p.src=new URL(({v2:'block-versions/our-coffees/v2.js',v3:'block-versions/our-coffees/v2.js',v4:'block-versions/our-coffees/v4.js',v5:'block-versions/our-coffees/v5.js',v6:'block-versions/our-coffees/v6.js',v7:'block-versions/our-coffees/v7.js',v8:'block-versions/our-coffees/v8.js'})[cv]||'/cdn/shop/t/5/assets/coffee-cards--acdef52b.js',base);p.onload=resolve;p.onerror=resolve;document.body.append(p);});if(window.amkaCardsReady)try{await window.amkaCardsReady;}catch(e){console.warn('Coffee cards unavailable',e);}
  if((window.AMKA_ROUTE||location.pathname).startsWith('/home/chamberlain/')||(window.AMKA_ROUTE||location.pathname).startsWith('/pdp/')){await new Promise(resolve=>{const loop=document.createElement('script');loop.src=new URL('/cdn/shop/t/5/assets/home-loop--16f049aa.js',base);loop.onload=resolve;loop.onerror=resolve;document.body.append(loop);});if(window.amkaLoopReady)await window.amkaLoopReady;}if((window.AMKA_ROUTE||location.pathname).startsWith('/home/chamberlain/')){const v=document.createElement('script');v.src=new URL('/cdn/shop/t/5/assets/section-versions--9adc889d.js',base);document.body.append(v);}
  const sizing=document.createElement('script');sizing.src=new URL('/cdn/shop/t/5/assets/product-scale--b34d3a70.js',base);document.body.append(sizing);
  if(!document.querySelector('link[href*="/cdn/shop/t/5/assets/moringa-block-review--6acc5ea4.css"]')){const css=document.createElement('link');css.rel='stylesheet';css.href=new URL('/cdn/shop/t/5/assets/moringa-block-review--6acc5ea4.css',base);document.head.append(css);}
  if(!document.querySelector('script[src*="/cdn/shop/t/5/assets/moringa-layout-editor--d83e1d1c.js"]')){const js=document.createElement('script');js.src=new URL('/cdn/shop/t/5/assets/moringa-layout-editor--d83e1d1c.js',base);document.body.append(js);}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',load,{once:true});else load();
})();
